// Clase del objeto TypeSagip.
class TypeSagip {
    // Constructor del objeto TypeSagip.
    constructor(props) {
        this.type = "TypeSagip";
        // noinspection DuplicatedCode
        if (props !== null) {
            this.id = props.id;
            this.name = props.name;
            this.acronym = props.acronym;
            this.detail = props.detail;
        } else {
            this.id = "-1";
            this.name = "";
            this.acronym = "";
            this.detail = "";
        }
    }
}

export default TypeSagip;